module.exports = __webpack_public_path__ + "static/media/handschuhe_richtig_active.f064b0f4.jpg";